import { RopFormFooter } from "../../../main/components/RopFormFooter";
import { useNavigate } from "react-router-dom";

export function ClientFormFooter(props: {
  selectedStep: number;
  handleNext: () => void;
  handleBack: () => void;
  handleSave: () => Promise<void>;
}) {
  const { handleNext, handleBack, handleSave } = props;
  const navigate = useNavigate();
  const onCancel = () => {
    navigate("/clients");
  };
  const save = async () => {
    try {
      await handleSave();
    } catch (error) {
      throw "Ocorreu um erro ao salvar o cliente";
    }
  };
  return (
    <RopFormFooter
      steps={4}
      handleBack={handleBack}
      handleNext={handleNext}
      onCancel={onCancel}
      handleSave={save}
      modalText="Tem certeza que deseja cancelar o cadastro de Cliente? "
      selectedStep={props.selectedStep}
    />
  );
}
